<div class="form-group row" *ngIf="control.visible" [formGroup]="formGroup">
  <div class="col-md-12">
    <hb-df-control-label [control]="control" (onOverrideValue)="overrideValue()"></hb-df-control-label>
  </div>
  <div class="col-md-12" *ngIf="control.allowUserEntry" style="display: flex">
    <p-autoComplete
      class="ac-box mr-1"
      [id]="control.leftKey"
      [inputId]="control.leftFormControlId"
      [formControlName]="control.leftKey"
      [suggestions]="filteredOptionsLeft"
      (completeMethod)="filterOptionsLeft($event)"
      (onSelect)="control.leftOnChange($event)"
      (onClear)="control.leftOnChange('')"
      [minLength]="1"
      [placeholder]="control.leftPlaceholder"
      [dropdown]="true"
    >
    </p-autoComplete>
    <p-autoComplete
      class="ac-mainbox ml-1"
      [id]="control.key"
      [inputId]="control.rightFormControlId"
      [formControlName]="control.key"
      [suggestions]="filteredOptionsRight"
      (completeMethod)="filterOptionsRight($event)"
      (onSelect)="control.rightOnChange($event)"
      (onClear)="control.rightOnChange('')"
      [minLength]="1"
      [placeholder]="control.placeholder || control.label"
      [dropdown]="true"
    >
    </p-autoComplete>
  </div>
  <div *ngIf="!control.allowUserEntry" class="col-md-12" style="display: flex">
    <select
      #leftDropdown
      class="form-control ac-box mr-1"
      [id]="control.leftKey"
      [placeholder]="control.leftPlaceholder"
      [formControlName]="control.leftKey"
      [disable]="control.disabled"
      (change)="control.leftOnChange(leftDropdown.value)"
    >
      <option *ngFor="let opt of control.options" [value]="opt[control.leftFieldName]">
        {{ opt[control.leftFieldName] }}
      </option>
    </select>
    <select
      #rightDropdown
      class="form-control ac-mainbox ml-1"
      [id]="control.key"
      [placeholder]="control.placeholder || control.label"
      [formControlName]="control.key"
      [disable]="control.disabled"
      (change)="control.rightOnChange(rightDropdown.value)"
    >
      <option *ngFor="let opt of control.options" [value]="opt[control.rightFieldName]">
        {{ opt[control.rightFieldName] }}
      </option>
    </select>
  </div>
</div>
